<template>
  <div id="caijixiangqingNew">
    <van-sticky>
      <van-nav-bar :title="title" left-text="返回" left-arrow @click-left="onClickLeft" />
    </van-sticky>

    <div class="xinxi">
      <div style="margin-bottom: 0.3rem">
        <div style="display: flex; justify-content: space-between">
          <div class="twoTitle" style="width: 1.7rem">任务名称：</div>
          <div style="display: flex; justify-content: space-between; width: calc(100% - 1.7rem)">
            <div class="twoLine">{{ taskName }}</div>
            <div
              class="text-box"
              :style="{
                color:
                  rightText.indexOf('已审核') > -1
                    ? 'green'
                    : rightText.indexOf('退回') > -1
                    ? 'red'
                    : rightText.indexOf('待审核') > -1
                    ? 'blue'
                    : 'red'
              }"
            >
              {{ rightText }}
            </div>
          </div>
        </div>
      </div>
      <div style="margin-bottom: 0.3rem">
        <van-row>
          <van-col span="4.5" class="twoTitle">采集地点：</van-col>
          <van-col span="14" class="twoLine">
            <div class="selectDiv">
              <van-dropdown-menu class="select" active-color="#4494f3" :overlay="false">
                <van-dropdown-item v-model="StationCode" :options="stationList" @change="dataGrid" @open="selectOpen" />
              </van-dropdown-menu>
            </div>
          </van-col>
          <van-col span="5" class="twoLine">
            <van-button type="primary" size="mini" @click="nextStation">下一条</van-button>
          </van-col>
        </van-row>
      </div>
      <div>
        <van-row>
          <van-col span="4.5" class="twoTitle">期&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;号：</van-col>
          <van-col span="7" class="twoLine">
            {{ exeno }}
          </van-col>
          <van-col span="4.5" class="twoTitle">截止时间：</van-col>
          <van-col span="7" class="twoLine" style="color: red">{{ priceDate }} {{ lateReportTime }}</van-col>
        </van-row>
      </div>
    </div>

    <!-- 商品表格 -->
    <comList
      ref="listRef"
      :list="list"
      @handItemCLick="clickStoreName"
      :saveState="dis"
      :computeSetList="computeSetList"
      :computeNeed="computeNeed"
      :goodsInfosNeed="goodsInfosNeed"
    ></comList>

    <!-- 按钮 -->
    <div class="bottom">
      <div style="display: flex; box-shadow: 0px -1px 10px #0000004d; height: 100%; align-items: center">
        <div offset="1" style="text-align: center; flex: 1; position: relative" v-if="stateId == 11">
          <v-button class="btn1" @click="tuihui">退回</v-button>
        </div>
        <div :class="{ bianhui: dis }" offset="1" style="text-align: center; flex: 1; position: relative">
          <v-button class="btn1" @click="tongguo">审核</v-button>
        </div>
        <div :class="{ bianhui: dis }" offset="1" style="text-align: center; flex: 1; position: relative">
          <v-button class="btn1" @click="save">保存</v-button>
        </div>
        <div offset="1" style="text-align: center;flex: 1;position: relative;">
          <v-button class="btn1 btn2" @click="chaKanRiZhi">查看日志</v-button>
        </div>
      </div>
    </div>

    <!-- 商品详细信息弹窗 -->
    <detailDialog ref="detailRef" :saveState="dis" @saveBasic="saveBasic" :taskConfig="taskConfig" :levelNum="levelNum"></detailDialog>

    <!-- 查看日志弹窗 -->
    <logDialog ref="logRef" :logList="logList"></logDialog>

    <!--退回原因-->
    <backDialog :showBackInfo="showBackInfo" :backInfoTwo="backInfo" @confirm="saveBackInfo" @close="closeBackInfo"></backDialog>
  </div>
</template>
<script>
import { loading } from '@/common/loading';
import detailDialog from '@/components/detailDialog';
import logDialog from '@/components/logDialog';
import backDialog from '@/components/backDialog';
import comList from '@/components/comList';
import { getName } from '@/utils/getStateName.js';
import rulesInfoDeal from '@/utils/dataRules.js';
import { dataGrid, saveRow, getDateRecord, checkLogin, getCountryStationList, upOkCountry, countyBack } from '@/api/baseMsg';
import { taskRegularList, gsRe2, stationRegularList2 } from '@/utils/taskRegular.js';
import validRange from '@/utils/validRange.js';
import { Toast } from 'vant';
import { calculateListDataChange } from '@/utils/formulaCalculation.js';
// import { Dialog } from 'vant'
export default {
  name: 'caijixiangqingNew',
  components: {
    detailDialog,
    logDialog,
    comList,
    backDialog
  },
  data() {
    return {
      title: '填报审核详情',
      isLoading: false,
      list: [],
      loading: false,
      finished: false,
      code: this.$route.query.code,
      taskCode: this.$route.query.taskCode,
      exeno: this.$route.query.exeno,
      // StationCode: this.$route.query.StationCode,
      RegionCode: this.$route.query.RegionCode,
      taskID: this.$route.query.taskId,
      tempCode: this.$route.query.tempCode,
      // shopId: this.$route.query.shopId,
      shopId: '',
      shispflag: this.$route.query.shispflag, //市审核
      shengspflag: this.$route.query.shengspflag, //市审核 //1蓝2绿3灰
      active: Number(this.$route.query.active), //日报周报选中状态
      active2: this.$route.query.active2, //当期任务
      priceDate: this.$route.query.priceDate,
      lateReportTime: this.$route.query.lateReportTime,
      dis: true, //审核状态的事项不可提交
      showDetial: false, //展示商品说明
      shopIndex: '',
      shopName: '', //商品名称
      bqPrice: '', //本期价格
      bqPriceSave: '',
      isGoods: '', //无此品种  1无，0有
      brand: '', //品牌
      content: '', //说明
      contentSave: '',
      comments: '', //备注
      originBrand: '', //品牌产地
      originBrandShow: false,
      itemNumbersShow: false,
      itemNumbers: '', //数量
      ifShow: '', //为0的时候不显示 品牌文本框,1时显示
      shopIndex1: '',
      ids: [], //数据
      showLog: false, //展示日志列表
      logList: [], //日志列表
      showLogDetial: false, //展示日志详情
      loginStatus: true,
      levelNum: this.$route.query.levelNum, //用户等级
      //   xianspflag:this.$route.query.xianspflag,//用户等级

      dlrflag: this.$route.query.dlrflag, //待录入
      dsbflag: this.$route.query.dsbflag, //待上报
      ythflag: this.$route.query.ythflag, //已退回

      taskName: '', //任务名称
      stationName: '', //监测点
      stationList: [],
      stateId: '', //未填报0,未提交1,县市区已退回89,市级已退回90,省级已退回99('0','1','89','90','99')案件状态
      isOpen: false,
      oldList: [], //存放原始数据数组
      rightText: '',
      //退回原因
      backInfo: '',
      showBackInfo: false,
      msg: {
        row: {},
        form: {},
        rules: {},
        list: []
      },
      detailData: {},
      taskConfig: [],
      computeSetList: [], // 计算公式
      computeNeed: [], // 需要被计算的商品-商code数组
      goodsInfosNeed: [] // 需要被计算的商品-code数组
    };
  },
  created() {
    this.init();
  },
  mounted() {
    window.addEventListener('scroll', this.scrollToTop);
  },
  destroyed() {
    window.removeEventListener('scroll', this.scrollToTop);
  },
  watch: {
    stateId() {
      this.getStateName();
    }
  },
  methods: {
    init() {
      // 初始化暂未定
      loading(true);
      this.checkLogin();
      if (this.loginStatus) {
        this.getStationList();
      }
    },
    getStationList() {
      getCountryStationList({
        taskCode: this.taskCode,
        exeno: this.exeno
      }).then((res) => {
        res.forEach((i) => {
          i.value = i.codeValue;
          i.text = i.codeName;
        });
        this.stationList = res;
        this.StationCode = res[0].value;
        this.shopId = res[0].shopId;
        this.stateId = res[0].stateId;
        this.dataGrid();
      });
    },
    getStationList2() {
      getCountryStationList({
        taskCode: this.taskCode,
        exeno: this.exeno
      }).then((res) => {
        res.forEach((i) => {
          i.value = i.codeValue;
          i.text = i.codeName;
        });
        this.stationList = res;
        this.stationList.forEach((i) => {
          if (i.value == this.StationCode) {
            this.stateId = i.stateId;
          }
        });
      });
    },
    getStateName() {
      this.rightText = getName(this.stateId);
    },
    isUp(ext) {
      ext = ext + '';

      //未填报0,未提交1,县市区已退回89,市级已退回90,省级已退回99('0','1','89','90','99')案件状态
      return ['0', '1', '89', '90', '99', '11', '21'].indexOf(ext) !== -1;
    },
    selectOpen() {
      // 判断是否打开了下拉框
      this.isOpen = true;
    },
    //houcc 2021.04.07
    dataGrid(value) {
      if (value == undefined) {
        value = this.StationCode;
      }
      if (this.isOpen) {
        const dir = this.stationList.find((item) => item.value === value);
        this.stateId = dir.stateId;
        this.shopId = dir.shopId;
      }
      this.isOpen = false;
      // console.log(this.stateId);
      loading(true);
      if ((this.dsbflag != 2 || this.ythflag != 2) && this.shispflag == 3) {
        this.dis = false; //3是灰色 代表还未审核 //1蓝2绿3灰
      } else {
        this.dis = true;
      }
      if (this.active2 == 1 || !this.isUp(this.stateId)) {
        this.dis = true;
      }
      if (this.stateId == '11') {
        this.dis = false;
      }
      dataGrid({
        taskCode: this.taskCode,
        ExeNo: this.exeno,
        StationCode: this.StationCode,
        StateId: this.stateId
      }).then((result) => {
        let hbNum; //环比
        const res = result.dataList;
        const columnMap = result.columnMapSet;
        this.taskConfig = result.taskConfig;
        for (let i = 0; i < res.length; i++) {
          calculateListDataChange(this, result.computesetlist, res[i], i);
          if (columnMap[res[i].VarietyCode]) {
            const list = columnMap[res[i].VarietyCode];
            res[i].list = list;
          }
          this.taskName = res[i].taskName;
          this.stationName = res[i].stationname;

          let ringPrice = res[i].ringPrice; //上期 ringPrice
          let thisPrice = res[i].ThisPrice; //本期 ThisPrice
          if (res[i].ringIsGoods !== undefined) {
            res[i].isGoods = res[i].ringIsGoods;
          }
          if (res[i].ThisPrice == -1 || res[i].ThisPrice == '-') {
            res[i].ThisPrice = '';
            res[i].hbNum = '-';
            continue;
          }
          let dataType = res[i].dataType; //dataType,字符类型
          if (dataType == '1003' || !Number(ringPrice) || ringPrice == 0 || !Number(thisPrice)) {
            res[i].hbNum = '-';
            continue;
          }
          ringPrice = parseFloat(ringPrice);
          thisPrice = parseFloat(thisPrice);
          hbNum = ((thisPrice - ringPrice) / ringPrice) * 100;
          if (hbNum == Infinity || isNaN(hbNum)) {
            res[i].hbNum = '-';
          } else {
            if (hbNum > 0) {
              res[i].styleColor = 'red';
            } else if (hbNum < 0) {
              res[i].styleColor = 'green';
            } else {
              res[i].styleColor = 'black';
            }
            if (hbNum.toString().indexOf('.') != -1 && hbNum.toString().split('.')[1].length > 2) {
              hbNum = hbNum.toFixed(2);
            }
            res[i].hbNum = hbNum;
          }
        }
        this.list = res;
        this.oldList = JSON.parse(JSON.stringify(res));
        loading(false);
      });
    },
    //保存价格采集
    saveRow(type, editType) {
      loading(true);
      saveRow({
        taskID: this.taskID,
        TempCode: this.code,
        ExeNo: this.exeno,
        priceDate: this.priceDate,
        RegionCode: this.RegionCode,
        StationCode: this.StationCode,
        shopTaskId: this.shopId,
        json: JSON.stringify(this.list),
        taskCode: this.taskCode,
        editType: editType
      }).then((res) => {
        if (res.success) {
          if (type == 1) {
            this.upOK();
            return;
          }
          loading(false);
          Toast.success(res.info);
          this.getStationList2();
        } else {
          let message = '';
          if (typeof res.info == 'string') {
            message = res.info.replace(/<\/br>/g, '\n');
          } else {
            message = res.info[0];
          }
          Toast({
            message,
            position: 'center',
            overlay: true
          });
          Toast.setDefaultOptions({ duration: 3600 });
          setTimeout(() => {
            if (res.ids == undefined) return;
            if (res.ids != '') {
              this.ids = JSON.parse(JSON.stringify(res.ids.split(',')));
              let listIndex;
              for (let i = 0; i < this.list.length; i++) {
                if (this.list[i].VarietyCode == this.ids[0]) {
                  listIndex = i;
                }
                for (let j = 0; j < this.ids.length; j++) {
                  if (this.list[i].VarietyCode == this.ids[j]) {
                    this.list[i].VarietyCodeNew = this.ids[j];
                    continue;
                  }
                }
              }
              this.clickStoreName(this.list[listIndex], listIndex);
            }
          }, 3600);
        }
      });
    },
    //上报
    upOK() {
      upOkCountry({
        exeno: this.exeno,
        shopTaskIds: this.shopId,
        stationCode: this.StationCode,
        taskCode: this.taskCode
      }).then((res) => {
        if (res.code == 200) {
          loading(false);
          Toast.success(res.message);
          this.dis = true;
          this.getStationList2();
        } else {
          this.ids = res.ids;
          Toast.fail(res.info.replace(/<\/br>/g, '\n'));
        }
      });
    },
    tongguo() {
      if (!this.ifCheckUpOk()) return;
      //审核通过
      this.$dialog
        .confirm({
          message: '是否确认' + '审核通过' + '?'
        })
        .then(() => {
          // levelNum 1区县级 2 市级 3省级
          if (this.levelNum == 1) {
            this.saveRow(1, '5');
          } else if (this.levelNum == 2 && ['0', '1'].indexOf(this.stateId) > -1) {
            this.saveRow(1, '5');
          } else if (this.levelNum == 2 && this.stateId == '21') {
            this.cityCheck();
          } else if (this.levelNum == 3) {
            this.provinceCheck();
          }
          // if (this.id != undefined || this.id != "") {
          //采价周期id
          this.getTodayCheck();
          // }
        })
        .catch(() => {});
    },
    onClickLeft() {
      this.$router.push({
        path: '/qxtbcaiji/qxtbcaiji',
        query: {
          active: this.active,
          active2: this.active2,
          startTime: this.$route.query.startTime,
          endTime: this.$route.query.endTime
        }
      });
    },
    onLoad() {
      //初始化table
      loading(true);
      // this.dataGrid()
      setTimeout(() => {
        // 加载状态结束
        this.loading = false;
        // 数据全部加载完成
        this.finished = true;
      }, 1000);
    },
    //环比实时变化
    changePrice(i) {
      let hbNum;
      let ringPrice = this.list[i].ringPrice; //上期 ringPrice
      let thisPrice = this.list[i].ThisPrice; //本期 ThisPrice

      if (!Number(thisPrice)) {
        this.list[i].hbNum = '-';
        return;
      }
      if (thisPrice.split('.').length - 1 > 1) {
        Toast('本期价格输入格式不正确请重新输入!');
        return;
      }
      thisPrice = parseFloat(thisPrice).toFixed(this.list[i].report_digits);
      this.list[i].ThisPrice = thisPrice;
      if (!Number(ringPrice) || ringPrice == 0) {
        this.list[i].hbNum = '-';
        return;
      }
      ringPrice = parseFloat(ringPrice);
      thisPrice = parseFloat(thisPrice);
      hbNum = ((thisPrice - ringPrice) / ringPrice) * 100;
      if (hbNum == Infinity || isNaN(hbNum)) {
        this.list[i].hbNum = '-';
      } else {
        if (hbNum.toString().indexOf('.') != -1 && hbNum.toString().split('.')[1].length > 2) {
          hbNum = hbNum.toFixed(2);
        }
        if (parseInt(hbNum) > 0) {
          this.list[i].styleColor = 'red';
          this.list[i].HB = "<span style='color:red'>涨" + hbNum + '<span>';
        } else if (parseInt(hbNum) < 0) {
          this.list[i].styleColor = 'green';
          this.list[i].HB = "<span style='color:green'>跌" + hbNum + '<span>';
        } else {
          this.list[i].styleColor = 'black';
        }
        this.list[i].hbNum = hbNum;
      }
    },
    daoru() {
      loading(true);
      //导入上期
      for (let i = 0; i < this.list.length; i++) {
        if (this.list[i].ringPrice == '-' || this.list[i].ringPrice == '' || this.list[i].isGoods == 1) {
          continue;
        } else {
          this.list[i].isGoods = this.list[i].ringIsGoods;
          this.list[i].ThisPrice = this.list[i].ringPrice;
          if (this.list[i].ringPrice != 0) {
            this.list[i].styleColor = 'black';
            this.list[i].hbNum = 0;
          }
        }
      }
      setTimeout(() => {
        loading(false);
      }, 1000);
    },
    //判断是否复核判断条件
    ifCheckSaveRow() {
      try {
        validRange(this.list);
      } catch (error) {
        return false;
      }
      for (let i = 0; i < this.list.length; i++) {
        const item = this.list[i];
        if (
          this.ifNullOrEmpty(item.Memo, 0) &&
          ((item.ThisPrice == 0 && item.ThisPrice != '' && item.dataType !== '1003') ||
            (item.hbzks !== null && item.hbNum >= item.hbzks && item.hbNum > 0) ||
            (item.hbjks !== null && Math.abs(item.hbNum) >= item.hbjks && item.hbNum < 0))
        ) {
          Toast('数据' + item.VarietyName + '请填写波动原因说明!');
          this.clickStoreName(this.list[i], i);
          return false;
        }
      }
      return true;
    },
    ifCheckUpOk() {
      try {
        validRange(this.list);
      } catch (error) {
        return false;
      }
      for (let i = 0; i < this.list.length; i++) {
        const item = this.list[i];
        if (this.ifNullOrEmpty(item.Memo, 1)) {
          Toast('数据' + item.VarietyName + '说明的字数不能太少，至少2个文字!');
          this.clickStoreName(this.list[i], i);
          return false;
        }
        if (
          this.ifNullOrEmpty(item.Memo, 0) &&
          ((item.ThisPrice == 0 && item.ThisPrice != '' && item.dataType !== '1003') ||
            (item.ThisPrice == '' && item.dataType !== '1003') ||
            (item.importInfo == '' && item.dataType == '1003') ||
            (item.hbzks !== null && item.hbNum >= item.hbzks && item.hbNum > 0) ||
            (item.hbjks !== null && Math.abs(item.hbNum) >= item.hbjks && item.hbNum < 0))
        ) {
          Toast('数据' + item.VarietyName + '请填写波动原因说明!');
          this.clickStoreName(this.list[i], i);
          return false;
        }
        let bq = item.ThisPrice;
        let sq = item.ringPrice;
        let multiPrice = item.sameNumPrice;
        let multiCount = item.sameNum;
        let multiCountTwo = item.sameNum;
        if (Number(bq) > 0 && Number(sq) > 0 && multiPrice && item.dqbb) {
          if (parseFloat(bq) === parseFloat(multiPrice)) {
            multiCountTwo = multiCountTwo + 1;
          }
          if (multiCountTwo >= item.dqbb && !item.Memo && parseFloat(bq) == parseFloat(multiPrice)) {
            Toast(`${item.VarietyName}价格${parseInt(multiCountTwo)}期不变, 请填写说明!`);
            this.clickStoreName(this.list[i], i);
            return false;
          }
        }
        let flag = true;
        if (item.list) {
          item.list.forEach((a) => {
            if ((item[a.fieldName] == '' || !item[a.fieldName]) && a.ifMust == 1 && !item.isGoods) {
              Toast('请填写' + item.VarietyName + '的商品信息!');
              this.clickStoreName(this.list[i], i);
              flag = false;
              return false;
            }
          });
          if (!flag) {
            return false;
          }
        }
      }
      return true;
    },
    ifNullOrEmpty(obj, type) {
      var regu = '^[ ]+$';
      var re = new RegExp(regu);
      if (type == 0 && (typeof obj == 'undefined' || obj == null || obj == '' || re.test(obj))) {
        return true;
      } else if (!(typeof obj == 'undefined' || obj == null || obj == '' || re.test(obj)) && obj.length < 2 && type == 1) {
        return true;
      } else {
        return false;
      }
    },
    save() {
      //保存
      if (!this.ifCheckSaveRow()) return;
      // this.saveRow(0, "2");
      if (['89', '90', '99'].indexOf(this.stateId) !== -1) {
        //退回并修改 4
        this.saveRow(0, '4');
      } else {
        this.saveRow(0, '2');
      }
    },
    shangbao() {
      if (!this.ifCheckUpOk()) return;
      //上报
      this.$dialog
        .confirm({
          message: '上报之后不能再进行修改，是否确认上报?'
        })
        .then(() => {
          this.saveRow(1, '5');
          //   this.upOK();
        })
        .catch(() => {});
    },
    // 点击商品名
    clickStoreName(item, index) {
      this.shopIndex = index;
      this.detailData = item;
      this.detailData.shopIndex1 = index + 1;
      let reason = rulesInfoDeal(item);
      if (reason.isWarn && reason.warnMsg) {
        this.detailData.placeholder = reason.warnMsg;
      } else {
        this.detailData.placeholder = '';
      }
      this.$refs.detailRef.initData(this.detailData);
    },
    //保存弹框信息
    saveBasic(row) {
      if (row.bqPrice > 99999999) {
        row.bqPrice = 99999999;
      } else if (row.bqPrice < 0) {
        row.bqPrice = 0;
      }
      this.list[this.shopIndex].ThisPrice = row.bqPrice; //本期价格
      this.list[this.shopIndex].Memo = row.content; //说明
      this.list[this.shopIndex].comments = row.comments; //备注
      this.list[this.shopIndex].isGoods = row.isGoods ? 1 : 0; //无此品种
      this.list[this.shopIndex].importInfo = row.importInfo; //本期价格-字符
      this.$refs.listRef.changePrice('', this.shopIndex);
    },
    // 查看日志按钮
    chaKanRiZhi() {
      this.$refs.logRef.show();
      loading(true);
      this.getDateRecord();
    },
    //查看日志
    getDateRecord() {
      getDateRecord({
        taskId: this.taskID,
        exeNo: this.exeno,
        stationCode: this.StationCode
      }).then((res) => {
        this.logList = res;
        loading(false);
      });
    },
    //监测登陆状态 houcc 2021.07.24
    checkLogin() {
      checkLogin({}).then((res) => {
        if (!res.success) {
          // nativeJSBridge.logout();
          this.$router.push({ path: '/loginOld' });
        }
        this.loginStatus = res.success;
      });
    },
    tuihui() {
      //退回修改
      this.backInfo = '';
      this.showBackInfo = true;
    },
    // 关闭退回弹框
    closeBackInfo() {
      this.showBackInfo = false;
    },
    saveBackInfo(val) {
      this.backInfo = val;
      this.$dialog
        .confirm({
          message: '退回之后不可再操作数据，是否确认退回?'
        })
        .then(() => {
          this.countyRedo(); //区县退回
          // this.getTodayCheck();
          this.showBackInfo = false;
        })
        .catch(() => {});
    },
    //区县退回
    countyRedo() {
      loading(true);
      countyBack({
        ID: this.shopId,
        backInfo: this.backInfo,
        exeno: this.exeno,
        taskCode: this.taskCode,
        stationCode: this.StationCode,
        taskId: this.taskID
      }).then((res) => {
        if (res.code == 200) {
          loading(false);
          Toast.success(res.message);
          this.getStationList2();
        } else {
          Toast.fail(res.message.replace(/<\/br>/g, '\n'));
        }
      });
    },
    // 点击下一条监测地点
    async nextStation() {
      // debugger
      // if(!this.compareArray(this.list, this.oldList)) {
      //   await this.save();
      // }
      this.ifUpdateStation();
    },
    //判断是否改变了值
    ifUpdateStation() {
      //判断是否修改了审核数据
      for (let i = 0; i < this.stationList.length; i++) {
        if (this.StationCode === this.stationList[i].value) {
          if (i + 1 < this.stationList.length) {
            this.StationCode = this.stationList[i + 1].value;
            this.shopId = this.stationList[i + 1].shopId;
            this.stateId = this.stationList[i + 1].stateId;
            // this.dataGrid()
            this.isOpen = true;
            this.dataGrid(this.StationCode);
          } else {
            this.StationCode = this.stationList[0].value;
            this.shopId = this.stationList[0].shopId;
            this.stateId = this.stationList[0].stateId;
            // this.dataGrid()
            this.isOpen = true;
            this.dataGrid(this.StationCode);
          }
          break;
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped>
#caijixiangqingNew {
  background: #f0f2f1;
  height: 100%;
  /deep/.van-nav-bar__text:active {
    background-color: transparent;
    .van-nav-bar__text {
      color: yellow !important;
      padding: 4px;
      font-size: px2rem(34) !important;
    }
  }
  /deep/.van-nav-bar__right {
    .van-nav-bar__text {
      color: yellow !important;
      padding: 4px;
      font-size: px2rem(34) !important;
    }
  }
  .xinxi {
    padding-left: 0.363rem;
    padding-right: 0.1rem;
    padding-top: 0.3rem;
    padding-bottom: 0.1rem;
    width: calc(100vw - 0.463rem);
    min-height: 2.3rem;
    background-color: #ffffff;
    font-size: px2rem(36);
    color: #4494f3;
    vertical-align: middle;
    margin-bottom: 0.2rem;
  }
  .bottom {
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 1.2rem;
    background-color: #fff;
    .btn1 {
      display: inline-block;
      vertical-align: middle;
      text-align: center;
      font-size: px2rem(45);
      color: #2c7fe2;
      font-weight: bold;
      font-family: 'Microsoft YaHei', 微软雅黑, Arial, sans-serif;
      width: 2rem;
      // border-right: 1px solid #ababab;
    }
    v-button.btn1::after {
      content: '';
      width: 0.02rem;
      height: 0.6rem;
      background: #ababab;
      position: absolute;
      right: 0;
    }
    v-button.btn2::after {
      content: '';
      width: 0rem;
      height: 0rem;
      // background: #ababab;
      // position: absolute;
      // right: 0;
    }
  }
  //提交上报的事项 底部按钮变灰
  .bianhui {
    pointer-events: none;
    filter: grayscale(1);
    .btn1 {
      font-weight: 400;
      color: #ababab;
    }
  }

  /deep/.van-cell {
    padding: 5px 16px;
    line-height: 0.9rem !important;
  }
  .twoTitle {
    color: #666666;
  }
  .twoLine {
    color: #020202;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    line-height: 0.48rem;
    /deep/.van-button {
      padding: 0;
      margin: 0;
      height: 0.63333rem;
      line-height: 00.63333rem;
    }
  }
  .text-box {
    color: #ff6f00;
    font-family: PingFang SC;
    font-size: px2rem(38);
    padding: 0 0.05rem;
    letter-spacing: 0px;
    text-align: center;
    white-space: nowrap;
  }
  .select {
    width: 100%;
    height: 0.55rem;
    /deep/.van-cell .van-icon {
      line-height: inherit !important;
    }
    /deep/.van-dropdown-menu__title {
      width: 100%;
    }
    /deep/.van-popup--top {
      top: 0;
      left: 20.5%;
      width: 53%;
    }
    /deep/.van-ellipsis {
      color: #020202;
      font-size: px2rem(36);
    }
  }
  .long-label2 {
    /deep/.van-field__label {
      align-items: center;
      display: flex;
      width: 1rem !important;
    }
  }
  .selectDiv {
    width: 5.25rem;
    border: 0.5px solid #bcbcbc;
    /deep/.van-dropdown-menu__title::after {
      position: absolute;
      top: 50%;
      right: 3%;
    }
    /deep/.van-dropdown-menu__bar {
      height: 0.55rem;
      width: 100%;
    }
    /deep/.van-dropdown-item__option--active {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    /deep/ .van-cell {
      padding: 0.05rem 0.15rem;
      line-height: 0.8rem !important;
      width: 7rem;
    }
  }
}
</style>
